import HeaderCompact from './Compact'
import HeaderFull from './Full'
import HeaderMinimal from './Minimal'

export const headerTypeMap = {
  compact: HeaderCompact,
  full: HeaderFull,
  minimal: HeaderMinimal,
}

export const headerTypes = Object.keys(headerTypeMap) as Array<
  keyof typeof headerTypeMap
>
